// External Libraries
import * as React from "react";
import { formatText, formatDateString } from "bernie-l10n";

// Types
import { Hotel } from "typings/microserviceModels/hotels-flex-module";

// UITK
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";

// Components
import { ReviewCountAndRating } from "components/flexComponents/Hotels/components/ReviewCountAndRating";
import { showReviewCountAndRating } from "components/flexComponents/Hotels/components/FeaturedReviewContent";
import { useHotelsContext } from "components/flexComponents/Hotels/components/HotelsContext";

// Utils
import { getAddress } from "components/flexComponents/Hotels/utils/getAddress";
import PriceLockup from "../../views/HotelsViews/components/shared/PriceLockup";
import { HotelPriceLockupWithDates } from "../../utils/A11y/HotelPriceLockupWithDates";

interface SummarizedContentProps {
  hotel: Hotel;
  isMobile: boolean;
}

export const SummarizedContent: React.FC<SummarizedContentProps> = ({ hotel }) => {
  const { hotelName, reviewCount, hotelOverallReviewRating, featuredReviews } = hotel;
  const { context, model } = useHotelsContext();

  const language = context.locale?.split(/[_-]/);

  return (
    <UitkLayoutFlex direction="column" justifyContent="space-between">
      <UitkLayoutFlex justifyContent="space-between">
        <UitkLayoutFlexItem shrink={1} className="all-r-margin-one">
          <div>
            <UitkSpacing margin={{ blockend: "one" }}>
              <UitkHeading tag="h3" size={5} overflow="truncate-2-lines" data-testid="hotel-name">
                {hotelName}
              </UitkHeading>
            </UitkSpacing>
            <div className="uitk-type-300 all-b-padding-one">{getAddress(hotel)}</div>
          </div>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem shrink={0}>
          <PriceLockup
            hotel={hotel}
            priceA11y={new HotelPriceLockupWithDates(hotel, formatText, formatDateString)}
            hasGetRatesText
          />
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
      {showReviewCountAndRating(model.showGuestRating, reviewCount, hotelOverallReviewRating, featuredReviews) && (
        <ReviewCountAndRating
          hotelOverallReviewRating={hotelOverallReviewRating}
          reviewCount={reviewCount}
          language={language}
        />
      )}
    </UitkLayoutFlex>
  );
};
